/**
 * Automatski upisuje izabrane boje (properties.Boja) svih stavki u korpi
 * u cart.note (koje se prenosi u order.note na Shopify porudžbini,
 * odakle ga Navigator čita kao "Napomena").
 *
 * Koristi marker "---BOJE---" da razdvoji eventualni ručni unos kupca
 * (ako se ikad uključi cart-note polje) od automatski generisanog dela.
 */
(function () {
	var MARKER = '---BOJE---';
 
	function buildColorBlock(items) {
		var lines = items
			.filter(function (item) {
				return item.properties && item.properties['Boja'];
			})
			.map(function (item) {
				return item.product_title + ': ' + item.properties['Boja'];
			});
 
		if (lines.length === 0) {
			return '';
		}
 
		return MARKER + '\n' + lines.join('\n');
	}
 
	function syncCartNote() {
		fetch('/cart.js')
			.then(function (response) { return response.json(); })
			.then(function (cart) {
				var currentNote = cart.note || '';
				var markerIndex = currentNote.indexOf(MARKER);
				var manualPart = markerIndex >= 0 ? currentNote.slice(0, markerIndex).trim() : currentNote.trim();
				var colorBlock = buildColorBlock(cart.items);
 
				var newNote = manualPart;
				if (colorBlock) {
					newNote = manualPart ? manualPart + '\n\n' + colorBlock : colorBlock;
				}
 
				if (newNote === currentNote) {
					return;
				}
 
				return fetch('/cart/update.js', {
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({ note: newNote })
				});
			})
			.catch(function (e) {
				console.error('cart-note-color-sync failed', e);
			});
	}
 
	document.addEventListener('cart:item-add', syncCartNote);
	document.addEventListener('cart:item-quantity-update', syncCartNote);
	document.addEventListener('cart:item-remove', syncCartNote);
})();